module.exports = "https://web-assets.ifttt.com/packs/media/icons/search-f2a06d20.svg";